import { MenuItem, PrimeIcons } from "primeng/api";
import { UserPermission } from "./permission.constants.enum";
import { environment } from "../../../environments/environment";

export interface NavigationItem extends MenuItem {
    shortTitle? : string;
    items?: NavigationItem[];
    visibleTo? : UserPermission[];
    pageTitle?: string;
    helpIndex?: number;
}

// Optional external link base URL
const UI_BASE_URL = environment.externalBaseUrl;

export const NAVIGATION_ITEMS: NavigationItem[] = [
    {
        label: 'Time Entry',
        items: [
            {
                label: 'Time Entry',
                title: 'Time Entry',
                icon: PrimeIcons.CLOCK,
                url: UI_BASE_URL + '/TimeEntry',
                visibleTo: [UserPermission.User],
                helpIndex: 1
            },
            {
                label: 'Status List',
                title: 'Status List',
                icon: PrimeIcons.EXCLAMATION_TRIANGLE,
                url: UI_BASE_URL + '/StatusList',
                visibleTo: [UserPermission.StatusList],
                helpIndex: 2
            },
            {
                label: 'Emulate',
                title: 'Emulate User',
                icon: PrimeIcons.USER,
                url: UI_BASE_URL + '/Emulate',
                visibleTo: [UserPermission.Emulate, UserPermission.EmulateAll],
                helpIndex: 3
            },
        ]
    },
    {
        label: 'Projects',
        visibleTo: [
            UserPermission.CutoffDate,
            UserPermission.ManageTimesheets,
            UserPermission.EEContractor,
            UserPermission.EEProject,
            UserPermission.EEProjectAll,
            UserPermission.Explanation
        ],
        items: [
            {
                label: 'Manage',
                title: 'Manage Projects',
                icon: PrimeIcons.DATABASE,
                url: UI_BASE_URL + '/ManageProjects',
                visibleTo: [UserPermission.EEProject, UserPermission.EEProjectAll],
                helpIndex: 7
            },
            {
                label: 'View',
                title: 'View Projects',
                icon: PrimeIcons.GAUGE,
                url: UI_BASE_URL + '/ViewProjects',
                visibleTo: [UserPermission.ViewProject],
                helpIndex: 7
            },
            {
                label: 'Reports',
                title: 'Project Reports',
                icon: PrimeIcons.FILE_EXPORT,
                routerLink: 'projects/reports',
                visibleTo: [UserPermission.EEProjectAll, UserPermission.EEProject, UserPermission.ViewProject],
                pageTitle: 'Reports - Projects',
                helpIndex: 10
            },
            {
                label: 'Explanations',
                title: 'Task Explanations',
                icon: PrimeIcons.LIST_CHECK,
                routerLink: 'projects/explanations',
                visibleTo: [
                    UserPermission.Explanation,
                    UserPermission.EEProjectAll
                ],
                pageTitle: 'Explanations - Projects',
                helpIndex: 9
            },
        ]
    },
    {
        label: 'Administration',
        shortTitle: 'Admin',
        visibleTo: [
            UserPermission.CutoffDate,
            UserPermission.ManageTimesheets,
            UserPermission.EEContractor,
            UserPermission.EEProject,
            UserPermission.EEProjectAll,
            UserPermission.Explanation
        ],
        items: [
            {
                label: 'Cutoff Date',
                title: 'Time Entry Cutoff Date',
                icon: PrimeIcons.CALENDAR,
                routerLink: 'administration/cutoff-date',
                visibleTo: [UserPermission.CutoffDate],
                pageTitle: 'Cutoff Date - Administration',
                helpIndex: 4
            },
            {
                label: 'Timesheets',
                title: 'Manage Timesheets',
                icon: PrimeIcons.FILE_EDIT,
                routerLink: 'administration/timesheets',
                visibleTo: [UserPermission.ManageTimesheets],
                pageTitle: 'ManageTimesheets - Administration',
                helpIndex: 5
            },
            {
                label: 'Users',
                title: 'Manage Users',
                icon: PrimeIcons.USER_EDIT,
                // url: UI_BASE_URL + '/Administration?screen=ManageUsers',
                routerLink: 'administration/manage-users',
                visibleTo: [UserPermission.EEContractor],
                pageTitle: 'Manage Users - Administration',
                helpIndex: 6
            },
            {
                label: 'Online Help',
                title: 'Online Help',
                icon: PrimeIcons.QUESTION_CIRCLE,
                routerLink: 'administration/online-help',
                visibleTo: [],
                pageTitle: 'Online Help - Administration',
            },
            {
                label: 'Downtime',
                title: 'Application Downtime',
                icon: PrimeIcons.EYE_SLASH,
                routerLink: 'administration/downtime',
                visibleTo: [],
                pageTitle: 'Downtime - Administration',
            },
        ]
    }
];

export enum SidebarState {
    EXPAND = 'Expand',
    COLLAPSE = 'Collapse'
}

export const COLLAPSED = 'collapsed';
